import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OnboardingActionsProvider, useOnboardingActions, } from './OnboardingActionsContext';
import { StickyCta } from '../components/StickyCta';
/**
 * 4 steps DEC-014 utility-first :
 *   welcome (consent fused) -> age-band -> signup -> intent.
 * AIDisclosure (ancien step 2) supprime, consent toggle dans Welcome.
 */
const STEPS = ['welcome', 'age-band', 'signup', 'intent'];
export function OnboardingFlow() {
    return (_jsx(OnboardingActionsProvider, { children: _jsx(OnboardingShell, {}) }));
}
function OnboardingShell() {
    const { t } = useTranslation('onboarding');
    const location = useLocation();
    const { actions } = useOnboardingActions();
    const last = location.pathname.split('/').filter(Boolean).pop() ?? 'welcome';
    const currentStep = STEPS.indexOf(last);
    return (_jsxs("section", { className: "flex min-h-[calc(100dvh-160px)] flex-1 flex-col", children: [_jsx("nav", { "aria-label": t('flow.aria_progress'), className: "flex items-center justify-center gap-2 pt-4 pb-6", children: STEPS.map((step, idx) => {
                    const isActive = idx <= currentStep;
                    return (_jsx("span", { "aria-hidden": "true", className: `block h-[2px] w-8 transition ${isActive ? 'bg-cyan-network' : 'bg-cyan-border-faint'}` }, step));
                }) }), _jsxs("div", { className: "flex flex-1 flex-col pb-6", children: [_jsx(Outlet, {}), _jsx("div", { "aria-hidden": true, className: "h-[120px]" })] }), actions ? _jsx(StickyCta, { children: actions }) : null] }));
}
//# sourceMappingURL=OnboardingFlow.js.map